export default (axios) => ({
  list() {
    return axios.get('v1/prices')
  }
})
